<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0">Calificaciones Parciales</h3>
                        </div>
                    </v-card-title>
                    <v-card-text v-if="$mq !== 'sm'">
                        <v-data-table
                                :headers="headers"
                                :items="items"
                                hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <td>
                                    <b>{{ props.item.materia.nombre }}</b><br>
                                    {{ props.item.materia.clave }}
                                </td>
                                <td class="text-xs-left" v-for="calificacion in props.item.calificaciones">{{ calificacion }}</td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-expansion-panel class="mb-1" v-if="$mq === 'sm'">
                    <v-expansion-panel-content
                        v-for="item in items" :key="item.materia.clave"
                >
                        <div slot="header">
                            <div><h4>{{ item.materia.nombre }}</h4></div>
                            <div>{{ item.materia.clave }}</div>
                        </div>
                        <v-card>
                            <v-divider></v-divider>
                            <v-list dense>
                                <v-list-tile v-for="(calificacion, index) in item.calificaciones" :key="index" @click="">
                                    <v-list-tile-content>{{ (index + 1) }} Parcial:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{ calificacion }}</v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="280px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando Calificaciones</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'CalificacionesParcialesPage',
    data: () => ({
      cargandoDatos: false,
      headers: [
        { text: 'Materia', value: 'materia.nombre' },
        { text: '1r. Parcial', value: 'calificacion', sortable: false },
        { text: '2o. Parcial', value: 'calificacion', sortable: false },
        { text: '3r. Parcial', value: 'calificacion', sortable: false },
        { text: '4o. Parcial', value: 'calificacion', sortable: false },
        { text: '5o. Parcial', value: 'calificacion', sortable: false },
        { text: '6o. Parcial', value: 'calificacion', sortable: false },
        { text: '7o. Parcial', value: 'calificacion', sortable: false },
        { text: '8o. Parcial', value: 'calificacion', sortable: false }
      ],
      items: []
    }),
    methods: {
      getCalificacionesParciales () {
        this.cargandoDatos = true
        axios.get('alumno/calificaciones-parciales')
          .then(response => {
            this.cargandoDatos = false
            this.items = response.data
          })
      }
    },
    created () {
      this.getCalificacionesParciales()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/information/CalificacionesParcialesPage.vue